import { render, staticRenderFns } from "./ViewEmployeesBody.vue?vue&type=template&id=52c4ee0e&scoped=true"
import script from "./ViewEmployeesBody.vue?vue&type=script&lang=ts"
export * from "./ViewEmployeesBody.vue?vue&type=script&lang=ts"
import style0 from "./ViewEmployeesBody.vue?vue&type=style&index=0&id=52c4ee0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c4ee0e",
  null
  
)

export default component.exports